import moment from "moment";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { v4 as uuidv4 } from "uuid";
import checkVal from "@/utils/checkVal";
import videoUpload from "@/components/course/upload.vue";
import Vue from "vue";
import scrollToMenu from "@/components/course/scrollCum.vue";
import VueTagsInput from "@johmun/vue-tags-input";
import returndia from "@/components/course/Return.vue";
import draggable from "vuedraggable";
import _ from "lodash";

export const GlobalRes = {
  data() {
    return {
      // 品牌数据
      brandList: [],
      agurl: "/learning/courseinfo/download",
      isFour: false,
      isOrderStudyList: [
        {
          value: "10",
          label: "是",
        },
        {
          value: "20",
          label: "否",
        },
      ],
      examIndex: 1,
      //控制选择推荐课程点击行事件
      isSelectCourseOk: true,
      // 考试分页数据
      pageExam: 1,
      limitExam: 10,
      totalExam: 10,
      isTestShow: false,
      isTrainnerShow: false,
      isGroupShow: false,
      constH: [],
      pageResource: 1,
      numCourseDuration: "",
      totalGroup: 0,
      totalTest: 0,
      totalCountTrainner: 0,
      isresourceShow: false,
      totalCountResource: 0,
      pageTrainner: 1,
      limitTrainner: 20,
      pagePerson: 1,
      limitPerson: 20,
      pageGroup: 1,
      limitGroup: 20,
      pageRefer: 1,
      limitRefer: 20,
      checkIdsStronBtnRefer: "",
      // radio行点击数据
      currentSelectItem: {},
      currentSelectItemR: {},

      // check-box行点击数据
      multipleSelection: [],
      timer: "",
      durationResult: "",
      dataListLoading: false,
      dialogVisibleReurn: false,
      // 判断ai考试可选
      checkAIExam: true,
      teamTypeGroupsResult: [],
      teamTypeGroups: [],
      tagddd: "",
      tags: ["课程目标", "课程亮点", "课程介绍"],
      tagsO: ["课程目标", "课程亮点", "课程介绍"],
      tagsImportant: [],
      tagsContent: "",
      courseST: {
        // 基本信息
        defaultinformation: true,
        editinformation: false,
        finishinformation: false,
        // 课程介绍
        defaultlessonrefer: true,
        editlesson: false,
        finishlesson: false,
        //上传图片
        deafultuppic: true,
        edituppic: false,
        finishuppic: false,
        // 章节设置
        defaultchapter: true,
        editchapter: false,
        finishchapter: false,
        // 推荐课程
        defaultlessonreferer: true,
        editlessonrefer: false,
        finishlessonrefer: false,
        // 常见问题
        defaultquestion: true,
        editquestion: false,
        finishquestion: false,
      },
      moudleOneShow: true,
      moudleTwoShow: false,
      btnO: true,
      btnT: true,
      index: "",
      Picture: [],
      Text: [],
      videoUploadOne: [],

      PictureH: [],
      TextH: [],
      videoUploadH: [],

      PictureT: [],
      TextT: [],
      videoUploadT: [],
      aiExamFlag: "",
      saveCourseId: "",
      jsonlist: "",
      jsonlistT: "",
      isShowRefer: false,
      moduleOneIntro: [],
      moduleTwoIntro: [],
      moduleHomeIntro: [],
      ctList: [],
      cstList: [],
      ids: [],
      brandId: 10,
      teamType: "",
      teamTypeChild: "",
      courseName: "",
      isOrderStudy: "20",
      courseNameEn: "",
      classifyId: "",
      aiFlag: 0,
      aiTag: "",
      isExamRep: "",
      isExerciseRep: "",
      showExerciseInfo: "",
      showExamInfo: "",
      isShowExerciseInfo: false,
      isShowExamInfo: false,
      keyword: "",
      ktcCode: "",
      // 限制学习默认否
      isLimit: 0,
      // 结课证明设置默认否
      hasCertificateFlag: 10,
      isFree: "",
      moduleOne: "",
      moduleTwo: "",
      listPic: "",
      listPicResourceId: "",
      groupIds: [],
      teacherIds: [],
      testIds: [],
      groupListTest: [],
      inputtype1: "",
      inputType2: "",

      // 课程标准时长

      delSectionDialog: false,

      active: 0, // 当前激活的导航索引
      courseSearchVO: {
        courseCode: "",
        courseName: "",
        trainerName: "",
        createDateStart: "",
        createDateEnd: "",
      },
      contents: [],
      contentsJs: "",

      // 上传图片视频
      imageUrl1: "", // 图片
      imageUrl2: "", // 视频封面
      videoUrl: "", // 视频回显地址
      videoUrltest: "", //视频地址
      imageUrlThired: "",
      imageUrlSecond1: "", // 图片
      imageUrl2Second: "", // 视频封面
      videoUrlSecond: "", // 视频

      imageUrl1IH: "", // 图片
      imageUrl2IH: "", // 视频封面
      videoUrlIH: "", // 视频
      showResource: true,
      homeWorkTitle: "",
      hTime: "",
      resourceInH: [],

      inputHomeWork1: "",
      inputHomeWork2: "",
      examData: [],
      referData: [],

      casProps: {
        value: "cid",
        label: "text",
        children: "nodes",
      },
      casPropsGroup: {
        value: "teamTypeId",
        label: "name",
        children: "children",
      },
      referList: [],
      fileList: [],
      listTrainner: [],
      handleClose: "",
      listTest: [],
      dialogFormVisible3: false,

      options: [],

      LessonClassified: "",
      groupList: [],
      testListTig: [],
      testListTigTest: [],
      testTrainnerTag: [],
      testTrainnerTagTest: [],
      hiddenText: false,
      hidddenVideo: false,
      hiddenText2: false,
      hiddenPicture2: false,
      hidddenVideo2: false,
      listTrainners: [],
      lists: [],
      listTests: [],
      hiddenPicture: false,
      hiddenTextIH: false,
      hiddenPictureIH: false,
      hidddenVideoIH: false,
      hiddenText2IH: false,
      hiddenPicture2IH: false,
      hidddenVideo2IH: false,
      TypeDescId: "",
      CreateName: "",
      UpdateName: "",
      referListResult: [],
      //  资源推荐
      resourceShowSelect: false,
      optionsResource: this.enums["ResourceType"],
      team: [],
      team2: [
        {
          value: "50",
          label: "BBS-50",
        },
        {
          value: "51",
          label: "BBS-51",
        },
        {
          value: "52",
          label: "BBS-52",
        },
        {
          value: "53",
          label: "BBS-53",
        },
        {
          value: "54",
          label: "Others",
        },
        {
          value: "56",
          label: "H5",
        },
        {
          value: "57",
          label: "Non TA",
        },
      ],
      options2: [],
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      resourceShow: false,
      resourceShowExam: false,
      resourceShowHomeWork: false,
      resourceShowinHome: false,
      currentPage2: 1,
      radio: null,
      page: 1,
      limit: 10,
      totalCount: 200,
      groupId: null,
      tableData: [],
      leftListResource: [],
      formInline: {
        name: "",
      },
      examFormLine: {
        name: "",
        person: "",
      },
      referFormLine: {
        courseCode: "",
        courseName: "",
        teamType: "",
        trainerName: "",
        createDateStart: "",
        createDateEnd: "",
      },
      list: [],
      data: [],
      defaultProps: {
        children: "childList",
        label: "groupName",
      },
      classifitedProps: {
        label: "text",
        children: "nodes",
      },
      // 章节设置
      currentChapterId: "",
      chapters: [],
      currentSections: [],
      currentEditSectionId: "",
      currentSectionOverId: "",
      // 创建问题
      inputList: [],
      fixed: false,
      exerciseRep: true,
      scrollTop: 0,
      approvalMode: 0,
      regionMode: 1,
      operationApprovalModeSelect: [
        { label: "无需审批", value: 0 },
        { label: "培训师审批", value: 1 },
        { label: "仅店内审批", value: 2 },
        { label: "店内及培训师审批", value: 3 },

        // { label: '仅培训师审批', value: 4 },
        // { label: '店内及培训师审批', value: 5 },
      ],
      isShowApprovalModePost: false,
      choosePostDialog: false,
      searchPortForm: {
        positionId: "",
        classifyId: "",
      },
      postList: [],
      cheekPostList: [],
      positionList: [],
      filterPosition: this.enums["filterPosition"] || [],
      classifyList: [],
      saveDataVisible: false,
      postChoosedList: [],
    };
  },
  mounted() {
    console.log(this.enums);
    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll, false);
  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    currentChapter() {
      if (this.currentChapterId) {
        return this.chapters.find((item) => item.id === this.currentChapterId);
      }
      return {};
    },
  },
  components: {
    checkVal,
    vueDropzone: vue2Dropzone,
    videoUpload,
    scrollToMenu,
    VueTagsInput,
    returndia,
    draggable,
  },
  methods: {
    getListTeamParentType() {
      this.$request
        .post("/course/listTeamParentType")
        .then((res) => {
          console.log(res, "res");
          this.team = res;
          console.log(this.team, "this.listTeamParentType=========");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getListBrand() {
      this.$request
        .post("/course/getBrandClassify")
        .then((res) => {
          console.log(res, "brandres=======");
          this.brandList = res;
          console.log(this.brandList, "this.brandList=========");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTeamTypeClassify() {
      this.$request
        .post("/course/getTeamTypeClassify")
        .then((res) => {
          console.log(res, "getTeamTypeClassify=======");
          this.teamTypeGroups = res;
          console.log(this.teamTypeGroups, "this.brandList=========");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    regionModeChange(val) {
      console.log(val);
      if (val == 1) {
        this.saveDataVisible = true;
      }
    },
    saveDataVisibleFun() {
      this.saveDataVisible = false;
    },
    async handlePostDialog() {
      let params = new FormData();
      params.append("pageSize", 999999);
      params.append("pageNo", 1);
      const res = await this.$request.post(
        `/course/searchPositionByPage`,
        params
      );
      let mapData = this.filterPosition.map((o) => {
        return o.code;
      });
      let arrResp = res.filter((item) => {
        return mapData.indexOf(item.jobCode) < 0;
      });
      arrResp.forEach(
        (i) => (i.jobCodeWithPosition = i.jobCode + "-" + i.positionNameCn)
      );
      this.postList = arrResp;
      this.positionList = arrResp;
      this.classifyList = _.uniqBy(arrResp, "classifyId");
      if (this.postChoosedList.length) {
        this.$nextTick(() => {
          this.postList.forEach((item) => {
            const matchIndex = this.postChoosedList.findIndex(
              (i) => i.positionId == item.positionId
            );
            this.$refs.postTableRef.toggleRowSelection(item, matchIndex != -1);
          });
        });
      } else {
        this.$nextTick(() => {
          this.postList.forEach((item) => {
            this.$refs.postTableRef.toggleRowSelection(item, false);
          });
        });
      }
      this.choosePostDialog = true;
    },
    async handlePostSearch() {
      let params = new FormData();
      params.append("pageSize", 999999);
      params.append("pageNo", 1);
      params.append("positionId", this.searchPortForm.positionId);
      params.append("classifyId", this.searchPortForm.classifyId);
      const res = await this.$request.post(
        `/course/searchPositionByPage`,
        params
      );
      res.forEach(
        (i) => (i.jobCodeWithPosition = i.jobCode + "-" + i.positionNameCn)
      );
      this.postList = res;
    },
    handlePostListChoosed() {
      if (this.$refs.postTableRef.selection.length == 0) {
        this.$message.error("请选择岗位");
        return;
      }
      console.log(
        "this.$refs.postTableRef.selection",
        this.$refs.postTableRef.selection
      );
      this.postChoosedList = this.$refs.postTableRef.selection;
      this.choosePostDialog = false;
    },
    initChoosePost() {
      this.approvalMode = 1;
      this.regionMode = 0;
      this.postList = [];
      this.positionList = [];
      this.classifyList = [];
      this.postChoosedList = [];
    },
    approvalModeChange(v) {
      console.log(v);
      if (Number(v) < 2) {
        this.postChoosedList = [];
      }
      if (v == 1 || v == 3) {
        this.regionMode = 0;
      }
    },
    choosedItemClose(positionId) {
      this.postChoosedList = this.postChoosedList.filter(
        (i) => i.positionId != positionId
      );
    },
    // 分页, 当前页
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(3);
      return realVal;
    },
    // 群组分页
    pageCurrentChangeHandle(val) {
      this.pageGroup = val;
      this.selectGroup();
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.pageGroup = 1;
      this.limitGroup = val;
      this.selectGroup();
    },
    pageSizeChangeHandleRefer(val) {
      this.limitRefer = val;
      this.onBtnRefer();
    },
    pageCurrentChangeHandleRefer(val) {
      this.pageRefer = val;
      this.onBtnRefer();
    },
    onBtnReferSelect() {
      this.pageRefer = 1;
      this.onBtnRefer();
    },

    //考试分页size
    pageSizeChangeHandleExam(val) {
      this.limitExam = val;
      this.onBtnExam();
    },
    // 当前页
    pageCurrentChangeHandleExam(val) {
      console.log("当前页数据=====", val);
      this.pageExam = val;
      this.onBtnExam();
    },

    // 内测人员分页

    pageCurrentChangeHandlePerson(val) {
      this.pagePerson = val;
      this.selecTestPesron();
    },
    // 分页, 每页条数
    pageSizeChangeHandlePerson(val) {
      this.pagePerson = 1;
      this.limitPerson = val;
      this.selecTestPesron();
    },

    // 负责培训师分页
    pageCurrentChangeHandleTrainner(val) {
      console.log(val, "培训师分页=============");
      this.pageTrainner = val;
      this.selectTrainner();
    },
    // 分页, 每页条数
    pageSizeChangeHandleTrainner(val) {
      console.log(val, "trainer  limit page===============");
      this.limitTrainner = val;
      this.selectTrainner();
    },
    onMove() {
      return true;
    },
    getRowKeys(row) {
      return row.groupId;
    },
    getRowKeysTrainner(row) {
      return row.trainnerId;
    },
    getRowKeysTest(row) {
      return row.userId;
    },

    deleteResourceName() {
      this.resourceInH.resourceNames = "";
      this.showResource = true;
    },
    //, 小手
    pointerStyle() {
      return {
        cursor: "pointer",
        fontSize: "14px",
        fontFamily: "PingFang SC-Regular, ingFangSC-Regular, sans-serif",
        fontWeight: 400,
        color: "#252628",
      };
    },
    getRowKeysRefer(row) {
      return row.courseId;
    },
    // 点击行radio事件资源选择
    handleSelectionChangeResource(row) {
      console.log(this.radio, "radio===================");
      console.log(row, "row=======================");
      this.currentSelectItemR = row;
      if (row.resourceId) {
        this.radio = row.resourceId;
      }
    },

    chooseone(row) {
      console.log(row, "ow=========================");
      this.currentSelectItem = row;
      if (row.resourceId) {
        this.radio = row.resourceId;
      }
    },
    // 点击行radio事件考试
    handleSelectionChangeResourceExam(row) {
      console.log(this.radio, "radio===================");
      console.log(row, "row=======================");
      if (row) {
        this.currentSelectItem = row;
        this.radio = row.examId;
      }
    },
    chooseoneExam(row) {
      console.log(row, "ow=========================");
      if (row) {
        this.currentSelectItem = row;
        this.radio = row.examId;
      }
    },

    //点击当前行数据进行选中或取消复选框
    toggleSelection(row) {
      const filterArr = this.referListResult.filter((item) => {
        return item.courseId == row.courseId;
      });
      if (filterArr.length > 0) {
        this.$refs.multipleTable.toggleRowSelection(row);
        this.isFour = false;
      } else {
        if (this.isSelectCourseOk) {
          this.$refs.multipleTable.toggleRowSelection(row);
        }
      }
      if (this.isFour) {
        this.$message.warning("最多选择4个");
      }
      if (this.referListResult.length >= 4) {
        this.isFour = true;
      } else {
        this.isFour = false;
      }

      //通过ref绑定后这里使用$refs.table来操作bom元素
    },
    toggleSelectionGroup(row) {
      // console.log('toggleSelectionGroup', row);
      this.$refs.rowGroup.toggleRowSelection(row);
    },
    togglePostSelectionGroup(row) {
      console.log("2222222", row);
      this.$refs.postTableRef.toggleRowSelection(row);
    },
    toggleSelectionTrainner(row) {
      this.$refs.rowTrainner.toggleRowSelection(row);
    },
    toggleSelectionTestPesron(row) {
      this.$refs.rowTestPesron.toggleRowSelection(row);
    },

    // 选择推荐课程时间
    onTime(val) {
      let a = this.formatDay(val);
      let b = this.getDay(a, 1);
      console.log(a, "thiso.vasklsdjklgjsdjgkldsjlk");
      console.log(b, "加一天数据");
      if (a) {
        this.referFormLine.createDateStart = a;
      }
      if (b) {
        this.referFormLine.createDateEnd = b;
      }
    },
    // 时间加一天
    getDay(beginDate, days) {
      var beginDate = beginDate.split("-");
      var nDate = new Date(
        beginDate[1] + "-" + beginDate[2] + "-" + beginDate[0]
      ); //转换为MM-DD-YYYY格式
      var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000;
      var rDate = new Date(millSeconds);
      var year = rDate.getFullYear();
      var month = rDate.getMonth() + 1;
      if (month < 10) month = "0" + month;
      var date = rDate.getDate();
      if (date < 10) date = "0" + date;
      return year + "-" + month + "-" + date;
    },
    fn3(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.groupId) && res.set(arr.groupId));
    },
    fnTrainer(arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.trainnerId) && res.set(arr.trainnerId)
      );
    },
    fnTest(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.userId) && res.set(arr.userId));
    },
    // AG关联课程代码说明下载
    downloadAg() {
      window.open(
        "https://joylearningblob.blob.core.chinacloudapi.cn/resource/KTC_Liste.xlsx"
      );
    },
    // 负责培训师弹窗取消
    canceldialogFormVisible3() {
      this.dialogFormVisible3 = false;
    },
    canceldialogFormVisible1() {
      this.dialogFormVisible1 = false;
    },
    canceldialogFormVisible2() {
      this.dialogFormVisible2 = false;
    },
    input(data) {
      this.dialogVisibleReurn = data;
    },
    aiExamFlagChange() {
      if (this.aiExamFlag == 1) {
        this.exerciseRep = true;
        this.isExerciseRep = "";
        this.showExerciseInfo = "";
      }
      if (this.aiExamFlag == 0) {
        this.exerciseRep = false;
        this.isExerciseRep = 1;
        this.showExerciseInfo = 0;
      }
    },
    exerciseRepChange(val) {
      if (val == 0) {
        this.showExerciseInfo = "";
        this.isShowExerciseInfo = true;
      } else {
        this.showExerciseInfo = 0;
        this.isShowExerciseInfo = false;
      }
    },
    aiExamChange(val) {
      if (val == 0) {
        this.showExamInfo = "";
        this.isShowExamInfo = true;
      } else {
        this.showExamInfo = 0;
        this.isShowExamInfo = false;
      }
    },
    checkAI() {
      if (this.aiFlag === 1) {
        this.checkAIExam = false;
        this.exerciseRep = false;
        if (this.aiExamFlag == "") {
          this.aiExamFlag = 0;
        }
        if (this.isExerciseRep == "") {
          this.isExerciseRep = 1;
        }
        if (this.isExamRep == "") {
          this.isExamRep = 1;
        }
        if (this.showExerciseInfo == "") {
          this.showExerciseInfo = 0;
        }
        if (this.showExamInfo == "") {
          this.showExamInfo = 0;
        }
      }
      if (this.aiFlag === 0) {
        this.checkAIExam = true;
        this.exerciseRep = true;
        this.aiExamFlag = "";
        this.isExamRep = "";
        this.isExerciseRep = "";
        this.showExerciseInfo = "";
        this.showExamInfo = "";
      }
    },
    tagcontent(tag) {
      console.log(tag, "this.tag");
      this.moduleTwo = tag;
    },
    tagdelete(index) {
      this.tags.splice(index, 1);
    },
    tagcontentO(tag) {
      console.log(tag, "this.tag");
      this.moduleOne = tag;
    },
    tagdeleteO(index) {
      this.tagsO.splice(index, 1);
    },
    getTreeData(data) {
      // 循环遍历json数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].nodes.length < 1) {
          // nodes若为空数组，则将nodes设为undefined
          data[i].nodes = undefined;
        } else {
          // nodes若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].nodes);
        }
      }
      return data;
    },
    delSectionOn(id) {
      const { checkLength, check, checkSum } = checkVal();
      this.delSectionDialog = false;
      this.currentSections.splice(this.index, 1);

      const numDuration = [];
      this.chapters.map((item, index) => {
        item.sections.map((_item, _index) => {
          // 计算时长
          if (_item.duration != null) {
            if (typeof _item.duration === "string") {
              numDuration.push(_item.duration - 0);
            } else {
              numDuration.push(_item.duration);
            }
          }
        });
      });

      console.log(checkSum(numDuration), "学习时长");
      this.numCourseDuration = checkSum(numDuration);
      this.numCourseDuration = this.numFilter(this.numCourseDuration) + "/天";

      this.updateSections();
    },

    moduleoneMethod() {
      this.moudleOneShow = true;
      this.moudleTwoShow = false;
      this.btnO = true;
      this.btnT = true;
    },
    moduleTwoMethod() {
      this.moudleTwoShow = true;
      this.moudleOneShow = false;
      this.btnO = false;
      this.btnT = false;
    },
    // 滚动监听器
    onScroll() {
      // 获取所有锚点元素
      const navContents = document.querySelectorAll(".content>div");
      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop);
      });
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义当前点亮的导航下标
      let navIndex = 0;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n;
        }
      }
      if (scrollTop > 200) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
      this.scrollTop = scrollTop;
      this.active = navIndex;
    },
    // 跳转到指定索引的元素
    scrollTo(index) {
      console.log(index, "index");
      // alert(index)
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      let targetOffsetTop = document.querySelector(
        `.content>div:nth-child(${index + 1})`
      ).offsetTop;
      // 获取当前 offsetTop
      if (index == 1) {
        console.log(111111111);
        targetOffsetTop = 1100;
      }
      if (index == 2) {
        targetOffsetTop = 1330;
      }
      if (index == 3) {
        targetOffsetTop = 1700;
      }
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 100;
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp();
      } else {
        // 往下滑
        smoothDown();
      }
      // 定义往下滑函数
      function smoothDown() {
        // alert('下滑')
        // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置\
        if (scrollTop < targetOffsetTop) {
          // 如果和目标相差距离大于等于 STEP 就跳 STEP
          // 否则直接跳到目标点，目标是为了防止跳过了。
          if (targetOffsetTop - scrollTop >= STEP) {
            // alert('22')
            scrollTop += STEP;
          } else {
            console.log(scrollTop);
            console.log(targetOffsetTop);
            // alert('33')
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop + 1;
          document.documentElement.scrollTop = scrollTop + 1;
          // 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
          requestAnimationFrame(smoothDown);
        } else {
          // alert('11')
          console.log("else");
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop + 1;
          document.documentElement.scrollTop = scrollTop + 1;
          requestAnimationFrame(smoothUp);
        }
      }
    },

    // 创建问题
    addInput() {
      this.inputList.push({
        question: "",
        answer: "",
      });
    },
    // 删除问题
    deleteRow(index, rows) {
      // rows.splice(index, 1);
      this.inputList.splice(index, 1);
    },
    delReferCourse(index) {
      console.log("删除方法记录");
      console.log(this.referList[index], "this.referlist==============");
      if (this.referListResult.length > 0) {
        this.referData.map((item, idsss) => {
          if (item.courseId == this.referList[index].courseId) {
            this.$refs.multipleTable.toggleRowSelection(
              this.referList[index],
              false
            );
          }
        });
      }

      this.referList.splice(index, 1);
      this.isFour = false;
      this.$forceUpdate();
    },
    formatDate(date, format = "YYYY-MM-DD HH:mm:ss") {
      return moment(date).format(format);
    },
    formatDay(date, format = "YYYY-MM-DD") {
      return moment(date).format(format);
    },
    uploadFileThired(item) {
      console.log(item, "上传图片");
      if (item.size > 4194304) {
        this.$message.error("图片大小不能超过4M");
        return;
      }

      let formData = new FormData();
      let file = item.raw;
      this.imageUrlThired = URL.createObjectURL(file);
      formData.append("file", file);
      this.listPicResourceId = this.imageUrlThired;
      console.log(this.listPicResourceId, "formData=====>");

      // 传formData
      this.$request
        .post("/course/uploadPic", formData, {
          Headers: {
            "Content-Type": "multipart/form-data;",
          },
        })
        .then((res) => {
          this.imageUrlThired = res;
          console.log(res, "路径图片");
        });
    },
    handleRemoveThired(file, fileList) {
      // console.log(file, fileList);
      this.imageUrlThired = "";
    },
    // -----上传图片视频功能end------
    // 删除群组
    delgroup(index) {
      this.list.map((v, i) => {
        if (v.groupId == this.groupList[index].groupId) {
          this.$refs.rowGroup.toggleRowSelection(v, false);
        }
      });
      this.groupList.splice(index, 1);
      this.groupListTest.splice(index, 1);
      this.ids = this.groupList.map((item) => item.groupId);
      console.log(this.ids, "==============ids");
      this.$forceUpdate();
    },
    // 删除内测人员
    delgroupTest(index) {
      this.listTest.map((v, i) => {
        if (v.userId == this.testListTig[index].userId) {
          this.$refs.rowTestPesron.toggleRowSelection(v, false);
        }
      });
      this.testListTig.splice(index, 1);
      this.testListTigTest.splice(index, 1);
      this.cstList = this.testListTig.map((item) => item.userId);
      console.log(this.cstList, "cstList=============");
      this.$forceUpdate();
    },
    // 负责培训师删除
    delgroupTrainner(index) {
      console.log(this.listTrainner, "listTrainner=====");
      console.log(this.testTrainnerTag, "trainnertag=======");
      this.listTrainner.map((v, i) => {
        if (v.trainnerId == this.testTrainnerTag[index].trainnerId) {
          console.log("方法进来了");
          this.$refs.rowTrainner.toggleRowSelection(v, false);
        }
      });
      this.testTrainnerTag.splice(index, 1);
      this.testTrainnerTagTest.splice(index, 1);
      this.ctList = this.testTrainnerTag.map((item) => item.trainnerId);
      console.log(this.ctList, "ctlist=============");
      this.$forceUpdate();
    },
    // 课程推荐
    selectCourseAfterHome() {
      this.resourceShowSelect = true;
      const arr = [];
      this.$nextTick(() => {
        this.referData.forEach((val) => {
          this.$refs.multipleTable.toggleRowSelection(
            val,
            this.referList.some((value) => value.courseId === val.courseId)
          );
        });
      });

      if (this.referList.length > 0) {
        this.referList.map((item) => {
          arr.push(item.courseId);
        });
        console.log(arr);
      }
      this.checkIdsStronBtnRefer = arr.join(",");
      this.onBtnRefer();
    },
    getTestPerson() {
      this.isTrainnerShow = true;
      this.$request
        .post("/course/searchUser", {
          ps: {
            pageNo: this.pagePerson,
            pageSize: this.limitPerson,
          },
          userSearchVO: {
            checkIdsStr: this.cstList.join(","),
          },
        })
        .then((res) => {
          this.totalTest = res.totalCount;
          console.log(">>>>", res);
          this.listTest = res.data;
          this.isTestShow = false;
        });
    },
    async testPerson() {
      this.listTests = [];
      this.pagePerson = 1;
      this.dialogFormVisible2 = true;
      this.isTestShow = true;
      const res = await this.$request.post("/course/searchUser", {
        ps: {
          pageNo: this.pagePerson,
          pageSize: this.limitPerson,
        },
        userSearchVO: {
          checkIdsStr: this.cstList.join(","),
        },
      });
      if (res) {
        this.totalTest = res.totalCount;
        this.listTest = res.data;
        this.isTestShow = false;
      }
      this.$nextTick(() => {
        this.listTest.forEach((val) => {
          this.$refs.rowTestPesron.toggleRowSelection(
            val,
            this.testListTig.some((value) => value.userId === val.userId)
          );
        });
      });
    },
    async trainer() {
      this.listTrainners = [];
      this.dialogFormVisible3 = true;
      this.isTrainnerShow = true;
      this.pageTrainner = 1;
      const res = await this.$request.post("/course/searchCourseTrainer", {
        ps: {
          pageNo: this.pageTrainner,
          pageSize: this.limitTrainner,
        },
        courseTrainerVO: {
          checkIdsStr: this.ctList.join(","),
        },
        trainerSearchVO: {},
      });
      if (res) {
        this.totalCountTrainner = res.totalCount;
        this.listTrainner = res.data;
        this.isTrainnerShow = false;
      }
      this.$nextTick(() => {
        this.listTrainner.forEach((val) => {
          this.$refs.rowTrainner.toggleRowSelection(
            val,
            this.testTrainnerTag.some(
              (value) => value.trainnerId === val.trainnerId
            )
          );
        });
      });
    },
    async clickGroup() {
      this.lists = [];
      this.dialogFormVisible1 = true;
      this.isGroupShow = true;
      this.pageGroup = 1;
      const res = await this.$request.post("/course/searchGroup", {
        ps: {
          pageNo: this.pageGroup,
          pageSize: this.limitGroup,
        },
        groupSearchVO: {
          // checkIdsStr:this.ids.join(","),
        },
      });
      if (res) {
        this.totalGroup = res.totalCount;
        console.log("查找组群数据", res);
        this.isGroupShow = false;
        this.list = res.data;
      }
      this.$nextTick(() => {
        this.list.forEach((val) => {
          this.$refs.rowGroup.toggleRowSelection(
            val,
            this.groupList.some((value) => value.groupId === val.groupId)
          );
        });
      });
    },
    // 章节设置
    onAddChapter() {
      const chapterTpl = {
        id: uuidv4(),
        name: "",
        sections: [],
      };

      this.chapters.push(chapterTpl);
      console.log(this.chapters, "章名称");
    },

    selectTeamTypes() {
      console.log("选择团队，点击事件进来了");
      console.log(this.teamType);
      this.options2 = "";
      this.$request
        .post(`/course/getTeamTypeChild?teamTypeId=${this.teamType}`, {})
        .then((res) => {
          this.options2 = res;
          console.log(this.options2);
        });
    },

    onAddSection() {
      if (this.chapters.length <= 0) {
        return this.$message.warning("请先选择要添加的章！");
      }
      const hasNotSavedSection = this.currentSections.find(
        (item) => !item.isSave
      );
      if (hasNotSavedSection) {
        this.$message.error("请先保存后再添加");
        return;
      }
      const sectionTpl = {
        id: uuidv4(),
        type: "",
        tag: [],
        name: "",
        location: "",
        disabled: true,
        chapterType: "",
        duration: "",
        optional: "",
        subChapterName: "",
        content: "",
        homeworkName: "",
        resourceId: "",
      };

      this.initChoosePost();

      this.chapters.forEach((element) => {
        if (element.id === this.currentChapterId) {
          element.sections.splice(element.sections.length, 0, sectionTpl);
        }
      });
      this.currentEditSectionId = sectionTpl.id;
      this.updateSections();
    },

    change(event) {
      console.log("change");
      console.log(event);
      console.log(event.moved.newIndex, "新索引");

      const sections = JSON.parse(JSON.stringify(this.currentSections));
      const chapters = JSON.parse(JSON.stringify(this.chapters));
      for (let i = 0; i < chapters.length; i++) {
        const element = chapters[i];
        if (element.id === this.currentChapterId) {
          element.sections = sections;
        }
      }

      this.chapters = chapters;
      this.updateSections();
    },
    onChooseChapter(id) {
      if (id) {
        this.currentChapterId = id;
        this.updateSections();
      }
    },
    updateSections() {
      if (this.currentChapterId) {
        const chapter = this.chapters.find(
          (item) => item.id === this.currentChapterId
        );
        this.currentSections = chapter.sections;
        return;
      }
      this.currentSections = [];
    },
    onNameUpdate(name) {
      this.chapters.forEach((element) => {
        if (element.id === this.currentChapterId) {
          element.name = name;
        }
      });
    },
    onOrderUp(id) {
      const tempChapters = JSON.parse(JSON.stringify(this.chapters));
      let tempElement = null;
      let tempIdx = -1;
      tempChapters.forEach((element, idx) => {
        if (element.id === id) {
          tempElement = element;
          tempIdx = idx;
        }
      });
      tempChapters.splice(tempIdx, 1);
      if (tempIdx - 1 >= 0) {
        tempChapters.splice(tempIdx - 1, 0, tempElement);
      }
      this.chapters = tempChapters;
    },
    onOrderDown(id) {
      const tempChapters = JSON.parse(JSON.stringify(this.chapters));
      let tempElement = null;
      let tempIdx = -1;
      tempChapters.forEach((element, idx) => {
        if (element.id === id) {
          tempElement = element;
          tempIdx = idx;
        }
      });
      tempChapters.splice(tempIdx, 1);
      if (tempIdx + 1 >= 0) {
        tempChapters.splice(tempIdx + 1, 0, tempElement);
      }
      this.chapters = tempChapters;
    },
    onDeleteChapter(id) {
      const tempChapters = JSON.parse(JSON.stringify(this.chapters));
      let tempIdx = -1;
      tempChapters.forEach((element, idx) => {
        if (element.id === id) {
          tempIdx = idx;
        }
      });
      tempChapters.splice(tempIdx, 1);

      if (id === this.currentChapterId) {
        this.currentChapterId = "";
      }
      this.chapters = tempChapters;
      this.updateSections();
    },
    onDeleteSection(id, index) {
      this.index = index;
      this.delSectionDialog = true;
    },

    onSectionSave(id) {
      const { checkLength, check, checkSum } = checkVal();
      let isName = false;
      this.currentSections.forEach((element, idx) => {
        if (element.id === id) {
          if (element.chapterType != "" && element.name != "") {
            element.isSave = true;
          }
          if (element.name == "") {
            isName = true;
            element.isSave = false;
            this.$message.error("请填写节名称");
          }
        }
        if (element.tag.length == 0) {
          element.isTag = true;
        }
        if (element.tag.length == 1) {
          if (element.tag[0] == "更新") {
            element.isTag = true;
          }
        }
      });
      if (isName) {
        return;
      }
      let numDuration = [];
      this.chapters.map((item, index) => {
        item.sections.map((_item, _index) => {
          // 计算时长
          if (_item.duration != null) {
            if (typeof _item.duration === "string") {
              numDuration.push(_item.duration - 0);
            } else {
              numDuration.push(_item.duration);
            }
          }
        });
      });

      console.log(checkSum(numDuration), "学习时长");
      this.numCourseDuration = checkSum(numDuration);
      this.numCourseDuration = this.numFilter(this.numCourseDuration) + "/天";

      this.currentEditSectionId = "";
    },

    onSectionEdit(id) {
      this.currentEditSectionId = id;
    },

    moveSectionLeft(id) {
      const sections = JSON.parse(JSON.stringify(this.currentSections));
      let tempElement = null;
      let tempIdx = -1;
      sections.forEach((element, idx) => {
        if (element.id === id) {
          tempElement = element;
          tempIdx = idx;
        }
      });

      if (tempIdx - 1 >= 0) {
        sections.splice(tempIdx, 1);
        sections.splice(tempIdx - 1, 0, tempElement);

        const chapters = JSON.parse(JSON.stringify(this.chapters));
        for (let i = 0; i < chapters.length; i++) {
          const element = chapters[i];
          if (element.id === this.currentChapterId) {
            element.sections = sections;
          }
        }

        this.chapters = chapters;
        this.updateSections();
      }
    },

    moveSectionRight(id) {
      const sections = JSON.parse(JSON.stringify(this.currentSections));
      let tempElement = null;
      let tempIdx = -1;
      sections.forEach((element, idx) => {
        if (element.id === id) {
          tempElement = element;
          tempIdx = idx;
        }
      });

      if (tempIdx + 1 >= 0) {
        sections.splice(tempIdx, 1);
        sections.splice(tempIdx + 1, 0, tempElement);

        const chapters = JSON.parse(JSON.stringify(this.chapters));
        for (let i = 0; i < chapters.length; i++) {
          const element = chapters[i];
          if (element.id === this.currentChapterId) {
            element.sections = sections;
          }
        }

        this.chapters = chapters;
        this.updateSections();
      }
    },

    onMouseOver(id) {
      this.currentSectionOverId = id;
    },

    onMouseLeave(id) {
      this.currentSectionOverId = "";
    },

    activeBtn(id) {
      this.currentSections.forEach((element, idx) => {
        if (element.id === id) {
          if (element.chapterType != "" && element.name != "") {
            element.disabled = false;
          }
        }
      });
    },

    searchTrainner() {
      this.pageTrainner = 1;
      this.selectTrainner();
    },
    searchGroup() {
      this.pageGroup = 1;
      this.selectGroup();
    },
    searchTestPeson() {
      this.pagePerson = 1;
      this.selecTestPesron();
    },
    // 查找培训师
    selectTrainner() {
      this.isTrainnerShow = true;
      this.$request
        .post("/course/searchCourseTrainer", {
          ps: {
            pageNo: this.pageTrainner,
            pageSize: this.limitTrainner,
          },
          courseTrainerVO: {
            trainnerName: this.listTrainners.trainnerNameCn,
            checkIdsStr: this.ctList.join(","),
          },
          trainerSearchVO: {},
        })
        .then((res) => {
          this.totalCountTrainner = res.totalCount;
          console.log(">>>>", res);
          this.listTrainner = res.data;
          this.isTrainnerShow = false;
        });
    },
    // 查找群组
    selectGroup() {
      this.isGroupShow = true;
      this.$request
        .post("/course/searchGroup", {
          ps: {
            pageNo: this.pageGroup,
            pageSize: this.limitGroup,
          },
          groupSearchVO: {
            groupName: this.lists.groupName,
            createName: this.lists.creatBy,
            // checkIdsStr:this.ids.join(","),
          },
        })
        .then((res) => {
          this.totalGroup = res.totalCount;
          this.isGroupShow = false;
          this.list = res.data;
        });
    },

    // 查找内测人员
    selecTestPesron() {
      this.isTestShow = true;
      this.$request
        .post("/course/searchUser", {
          ps: {
            pageNo: this.pagePerson,
            pageSize: this.limitPerson,
          },
          userSearchVO: {
            userName: this.listTests.realName,
            checkIdsStr: this.cstList.join(","),
          },
        })
        .then((res) => {
          this.totalTest = res.totalCount;
          console.log(">>>>", res);
          this.listTest = res.data;
          this.isTestShow = false;
        });
    },
    addText() {
      this.hiddenText = !this.hiddenText;
    },
    addTextIH() {
      this.hiddenTextIH = !this.hiddenTextIH;
    },
    addPicture() {
      this.hiddenPicture = !this.hiddenPicture;
    },
    addPictureIH() {
      this.hiddenPictureIH = !this.hiddenPictureIH;
    },
    addVideo() {
      this.hidddenVideo = !this.hidddenVideo;
    },
    addVideoIH() {
      this.hidddenVideoIH = !this.hidddenVideoIH;
    },
    addText2() {
      this.hiddenText2 = !this.hiddenText2;
    },
    addPicture2() {
      this.hiddenPicture2 = !this.hiddenPicture2;
    },
    addVideo2() {
      this.hidddenVideo2 = !this.hidddenVideo2;
    },
    selectAddGroup() {
      // this.groupList =this.groupListTest
      // this.groupListTest.map((item) => {
      //   this.groupList.push(item)
      // })
      this.groupList = this.groupListTest;
      this.dialogFormVisible1 = false;
      this.groupList = this.fn3(this.groupList);
      console.log(this.groupList, "选择后的面向群组数据");

      this.ids = this.groupList.map((item) => item.groupId);
    },
    testAddTig() {
      this.testListTig = this.testListTigTest;

      this.dialogFormVisible2 = false;
      this.testListTig = this.fnTest(this.testListTig);
      this.cstList = this.testListTig.map((item) => item.userId);
    },
    selectAddTrainner() {
      this.testTrainnerTag = this.testTrainnerTagTest;
      this.dialogFormVisible3 = false;
      this.testTrainnerTag = this.fnTrainer(this.testTrainnerTag);
      this.ctList = this.testTrainnerTag.map((item) => item.trainnerId);
      console.log(this.ctList, "负责培训师");
      console.log(this.testTrainnerTag, "选择后的数据");
    },

    // 推荐课程选择后数据
    isSelectCourse(row) {
      if (this.referListResult.length >= 4) {
        if (row.status == 1) {
          this.isSelectCourseOk = true;
          return true;
        } else {
          this.isSelectCourseOk = false;
          return false;
        }
      }
      this.isSelectCourseOk = true;
      return true;
    },
    handleSelectionChangeSelectCourse(val) {
      console.log(val, "this.val");
      this.referListResult = val;
      if (val.length > 3) {
        for (let j of this.referData) {
          j.status = 0;
          for (let i of val) {
            if (i.courseId == j.courseId) {
              j.status = 1;
            }
          }
        }
        return;
      } else {
        for (let i in this.referData) {
          this.referData[i].status = 1;
        }
      }
      console.log(this.referList, "选中后的推荐课程数据");
    },
    // 选中数据
    handleSelectionChange(val) {
      //选中后触发
      this.groupListTest = val;
      console.log(this.groupListTest, "选中后的面向群组数据");
    },
    handleSelectionChangeTest(e) {
      this.testListTigTest = e;
      console.log(this.testListTigTest, "选中后的内测人员数据");
    },
    handleSelectionChangeTrainner(val) {
      this.testTrainnerTagTest = val;
    },
    handleNodeClick(data) {
      console.log(data, "data");
      console.log(data.groupName); //左边选中行的名称
      console.log(data.groupId); //左边选中行的ID
      this.pageResource = 1;
      this.limit = 10;
      this.groupId = data.groupId;
      // this.formInline.name = "";
      this.isresourceShow = true;
      this.$request
        .post(
          `/course/listResourceByPageNew?groupId=${data.groupId}&keyword=${
            this.formInline.name
          }&createName=${this.CreateName}&updateName=${
            this.UpdateName
          }&typeDescId=${
            this.TypeDescId
          }&notIncludedAudio=${9}&status=${1}&notIncluded=${50}&showVrModelData=${true}`,
          {
            topclassifyid: data.groupId,
            pageNo: this.pageResource,
            pageSize: this.limit,
          }
        )
        .then((res) => {
          this.isresourceShow = false;
          this.totalCountResource = res.totalCount;
          this.totalCount = res.totalCount;
          this.tableData = res.data;
        });
    },
    closeForminH() {
      this.groupId = "";
    },
    onForminH() {
      this.resourceShowinHome = false;
      this.showResource = false;
      if (this.radio < 0 || this.raid === "") {
        this.$message.error("请选择");
        return;
      }
      let list = [];
      list.push(this.currentSelectItem);
      list.forEach((item) => {
        item.resourceNames = item.resourceName;
      });

      this.resourceInH = list;
      list = [];
      this.resourceInH = { ...this.resourceInH[0] };
    },
    // 选择课程当前行数据
    onFormsRefer() {
      this.resourceShowSelect = false;
      this.referList = this.referListResult;

      if (this.referList.length > 3) {
        this.referList = this.referList.splice(0, 4);

        return;
      }
      console.log(this.referList, "选择课程当前行数据当前行数据");
    },
    onForm() {
      if (this.radio < 0 || this.radio === "") {
        this.$message.error("请选择");
        return;
      }
      console.log(this.radio, "当前radio");

      this.chapters.forEach((item) => {
        item.sections.forEach((_item) => {
          if (
            _item.id === this.currentEditSectionId &&
            this.currentSelectItemR
          ) {
            (_item.name = this.currentSelectItemR.resourceName),
              (_item.location = this.currentSelectItemR.resourcePath),
              (_item.type = this.currentSelectItemR.typeDesc),
              (_item.chapterType = this.currentSelectItemR.type),
              (_item.resourceId = this.currentSelectItemR.resourceId),
              (_item.content = this.currentSelectItemR.resourceId),
              (_item.duration = this.currentSelectItemR.duration);
          }
        });
      });

      console.log(this.currentSections, "数据来了");
      this.resourceShow = false;
      console.log(555, this.currentSections, this.currentEditSectionId);
    },

    onForms() {
      if (this.radio < 0 || this.radio === "") {
        this.$message.error("请选择");
        return;
      }
      const index = this.currentSections.findIndex(
        (item) => item.id === this.currentEditSectionId
      );

      this.chapters.forEach((item) => {
        item.sections.forEach((_item) => {
          if (_item.id === this.currentEditSectionId) {
            if (this.currentSelectItem) {
              (_item.name = this.currentSelectItem.name),
                (_item.location = ""),
                (_item.type = "考试"),
                (_item.duration = this.currentSelectItem.standardDuration),
                (_item.chapterType = 5),
                (_item.content = this.currentSelectItem.examId);
            }
          }
        });
      });

      this.resourceShowExam = false;
    },
    async onFormIH() {
      const { checkLength, check, checkSum } = checkVal();
      console.log(this.homeWorkTitle, this.hTime, this.inputHomeWork1);
      if (
        checkLength(this.homeWorkTitle) ||
        check(this.hTime) ||
        checkLength(this.inputHomeWork1) ||
        this.hTime < 0
      ) {
        this.$message.warning("请填写必填项");
        return;
      }
      if (
        [2, 3, 5].indexOf(Number(this.approvalMode)) > -1 &&
        this.postChoosedList < 1
      ) {
        this.$message.warning("请选择店内审批职位");
        return;
      }

      if (this.moduleHomeIntro.length > 0) {
        for (let i = 0; i < this.moduleHomeIntro.length; i++) {
          if (this.moduleHomeIntro[i].type == 1) {
            // 作业文本
            if (
              this.moduleHomeIntro[i].value == "" ||
              this.moduleHomeIntro[i].value == null
            ) {
              this.$message.warning("作业的文字信息内容不能为空");
              return;
            }
          }
          if (this.moduleHomeIntro[i].type == 2) {
            if (
              this.moduleHomeIntro[i].value == "" ||
              this.moduleHomeIntro[i].value == null
            ) {
              this.$message.warning("作业图片不能为空");
              return;
            }
          }
          if (this.moduleHomeIntro[i].type == 3) {
            if (
              this.moduleHomeIntro[i].value == "" &&
              this.moduleHomeIntro[i].videoUrl == ""
            ) {
              this.$message.warning("作业视频不能为空");
              return;
            }
          }
        }
      }
      this.resourceShowHomeWork = false;
      let contentsResult = [];
      contentsResult = this.moduleHomeIntro;
      contentsResult.unshift({ type: 1, value: this.inputHomeWork1 });
      let contents2 = { content: contentsResult, versions: 1 };
      contents2 = JSON.stringify(contents2);
      let approvalStation = this.postChoosedList.length
        ? "," + this.postChoosedList.map((i) => i.positionId).toString() + ","
        : "";
      let region = 0;
      this.chapters.forEach((item) => {
        item.sections.forEach((_item) => {
          if (_item.id === this.currentEditSectionId) {
            _item.content = contents2;
            _item.homeworkName = this.homeWorkTitle;
            _item.location = "";
            _item.resourceInH = this.resourceInH;
            _item.resourceId = this.resourceInH.resourceId;
            _item.type = "作业";
            _item.duration = this.hTime;
            _item.chapterType = "6";
            _item.name = this.homeWorkTitle;
            if (this.regionMode == 1 && this.approvalMode == 1) {
              region = 4;
            } else if (this.regionMode == 1 && this.approvalMode == 3) {
              region = 5;
            } else {
              region = this.approvalMode;
            }
            _item.approvalMode = region;
            _item.approvalStation = approvalStation;
            _item.postChoosedList = this.postChoosedList;
          }
        });
      });

      console.log(this.contents, "作业数据");
    },
    // 点击考试触发
    exam() {
      this.resourceShowExam = true;
      this.resourceShowHomeWork = false;
      this.examIndex = 1;
      this.$request
        .post("/exam/listCourseExamByPage", {
          ps: {
            pageNo: 1,
            pageSize: 20,
          },
          examSearchVO: {
            status: 1,
            type: 1,
            creatBy: this.examFormLine.person,
            name: this.examFormLine.name,
          },
        })
        .then((res) => {
          this.examData = res.data;
          this.totalExam = res.totalCount;
          console.log("考试数据=======", res);
          console.log(this.examData, "左侧列表数据考试");
        });
    },
    homework() {
      console.log("作业方法进来了");
      this.examIndex = 2;
      this.resourceShowExam = false;
      this.resourceShowHomeWork = true;
    },
    handleCurrentChange(val) {
      this.isresourceShow = true;
      this.pageResource = val;
      this.onBtn();
    },
    onsetting() {
      console.log("222222");
      this.resourceShow = true;
      this.radio = "";
      this.formInline.name = "";
      this.TypeDescId = "";
      this.CreateName = "";
      this.UpdateName = "";
      this.groupId = "";
      this.pageResource = 1;
      this.tableData = [];
      this.chapters.forEach((item) => {
        item.sections.forEach((_item) => {
          if (_item.id === this.currentEditSectionId) {
            this.page = 1;
            if (!this.tableData) {
              this.isresourceShow = true;
              this.$request
                .post(
                  `/course/listResourceByPageNew?selectedResourceId=${_item.resourceId}`,
                  {
                    pageNo: this.page,
                    pageSize: this.limit,
                  }
                )
                .then((res) => {
                  this.isresourceShow = false;
                  this.totalCountResource = res.totalCount;
                  this.tableData = res.data;
                });
            }

            this.radio = _item.resourceId;
          }
        });
      });
      this.onBtn();
    },
    // 开始查找按钮
    onBtnSelectExam() {
      this.pageExam = 1;
      this.onBtnExam();
    },
    onBtnExam() {
      console.log("jinlai1le1");
      this.$request
        .post("/exam/listCourseExamByPage", {
          ps: {
            pageNo: this.pageExam,
            pageSize: this.limitExam,
          },
          examSearchVO: {
            status: 1,
            type: 1,
            creatBy: this.examFormLine.person,
            name: this.examFormLine.name,
          },
        })
        .then((res) => {
          this.examData = res.data;
          this.totalExam = res.totalCount;
          console.log("考试数据=======", res);
          console.log(this.examData, "左侧列表数据考试");
        });
    },
    onBtnRefer() {
      if (this.referFormLine.createDateEnd === "NaN-NaN-NaN") {
        (this.referFormLine.createDateStart = ""),
          (this.referFormLine.createDateEnd = "");
      }
      this.isShowRefer = true;
      this.$request
        .post("/course/searchCourseByPage", {
          ps: { pageNo: this.pageRefer, pageSize: this.limitRefer },
          courseSearchVO: {
            courseCode: this.referFormLine.courseCode,
            courseName: this.referFormLine.courseName,
            trainerName: this.referFormLine.trainerName,
            teamType: this.referFormLine.teamType,
            createDateStart: this.referFormLine.createDateStart,
            createDateEnd: this.referFormLine.createDateEnd,
            checkIdsStr: this.checkIdsStronBtnRefer,
            courseStatus: 2,
          },
        })
        .then((res) => {
          this.isShowRefer = false;
          this.referData = res.data;
          this.totalRefer = res.totalCount;
          console.log(this.referData, "关联课程数据");
        });
    },
    // 考试弹窗数据
    selectExam() {
      this.examFormLine.person = "";
      this.examFormLine.name = "";
      this.resourceShowExam = true;
      this.examIndex = 1;
      this.radio = "";
      this.chapters.forEach((item) => {
        item.sections.forEach((_item) => {
          if (_item.id === this.currentEditSectionId) {
            this.radio = _item.content;
            //  console.log(_item,"考试数据")
          }
        });
      });
      this.$request
        .post("/exam/listCourseExamByPage", {
          ps: {
            pageNo: 1,
            pageSize: 20,
          },
          examSearchVO: {
            status: 1,
            type: 1,
            creatBy: this.examFormLine.person,
            name: this.examFormLine.name,
          },
        })
        .then((res) => {
          this.examData = res.data;
          this.totalExam = res.totalCount;
          console.log("考试数据=======123", res.totalCount);
          console.log(this.examData, "左侧列表数据考试");
        });
    },
    // 作业弹窗数据
    selectHomeWork() {
      this.examIndex = 2;
      this.chapters.forEach((item) => {
        item.sections.forEach((_item) => {
          if (_item.id === this.currentEditSectionId) {
            if (_item.chapterType == 6) {
              if (_item.content.length > 0) {
                const arr = JSON.parse(_item.content);
                const arrs = arr.content[0];
                let moduleHome = [];
                moduleHome = arr.content;
                let resulet = [];
                resulet.push(moduleHome.shift());
                this.moduleHomeIntro = moduleHome;

                const inputHomeWork1 = arrs.value;
                this.inputHomeWork1 = inputHomeWork1;
                this.homeWorkTitle = _item.homeworkName;
                this.resourceInH = _item.resourceInH;
                let modeMap = {
                  0: 0,
                  1: 1,
                  2: 2,
                  3: 3,
                  4: 1,
                  5: 3,
                };
                this.approvalMode = modeMap[_item.approvalMode];
                if (_item.approvalMode > 3) {
                  this.regionMode = 1;
                } else {
                  this.regionMode = 0;
                }
                this.approvalStation = _item.approvalStation;
                this.postChoosedList = _item.postChoosedList;
              }

              if (this.resourceInH.resourceNames) {
                this.showResource = false;
              } else {
                this.showResource = true;
              }
              _item.location = "";
              _item.type = "作业";
              this.hTime = _item.duration;
              _item.chapterType = "6";
            } else {
              this.homeWorkTitle = "";
              this.hTime = "";
              this.inputHomeWork1 = "";
              this.TextH = [];
              this.showResource = true;
              this.PictureH = [];
              this.videoUploadH = [];
              this.moduleHomeIntro = [];
            }
          }
        });
      });
      this.resourceShowHomeWork = true;
    },
    // 选择资源作业
    selectRinH() {
      this.radio = "";
      this.groupId = "";
      this.formInline.name = "";
      this.pageResource = 1;
      this.tableData = [];
      this.onBtn();
      this.resourceShowinHome = true;
    },
    saveCourse() {
      this.dataListLoading = true;
      const { checkLength, check, checkSum } = checkVal();
      console.log(this.TextT, "=============================TextT");
      // 作业
      console.log(this.tagsImportant, "this.tagasgs");
      // todo修改   保存考试时要先，判断ai课程是否为1
      if (this.aiFlag == 0) {
        this.aiExamFlag = "";
      }
      // 关键字处理
      this.keyword = "";
      this.tagsImportant.map((item) => {
        if (this.keyword != "") {
          this.keyword = this.keyword + "," + item.text;
        } else {
          if (item.text) {
            this.keyword = item.text;
          } else {
            this.keyword = item;
          }
        }
      });

      if (this.keyword.length > 255) {
        this.$message.warning("关键字最多输入255个字符");
        this.courseST.editinformation = true;
        this.courseST.finishinformation = false;
        this.courseST.defaultinformation = false;
        this.dataListLoading = false;
        return;
      }
      console.log(this.keyword, "this.keyword");
      console.log(this.keyword.length, "this.keyword");
      // 基本信息
      this.courseST.defaultinformation = false;
      this.courseST.editinformation = false;
      (this.courseST.finishinformation = true),
        // 课程介绍
        (this.courseST.defaultlessonrefer = true);
      (this.courseST.editlesson = false),
        (this.courseST.finishlesson = false),
        //上传图片
        (this.courseST.deafultuppic = true),
        (this.courseST.edituppic = false),
        (this.courseST.finishuppic = false),
        // 章节设置
        (this.courseST.defaultchapter = true),
        (this.courseST.editchapter = false),
        (this.courseST.finishchapter = false),
        // 推荐课程
        (this.courseST.defaultlessonreferer = false),
        (this.courseST.editlessonrefer = false),
        (this.courseST.finishlessonrefer = true),
        // 常见问题
        (this.courseST.defaultquestion = false),
        (this.courseST.editquestion = false),
        (this.courseST.finishquestion = true);
      // 基本信息判断
      if (true) {
        if (
          check(this.brandId) ||
          this.teamTypeGroupsResult.length < 2 ||
          check(this.courseName) ||
          check(this.classifyId) ||
          check(this.ktcCode) ||
          check(this.keyword) ||
          check(this.isLimit) ||
          check(this.hasCertificateFlag) ||
          check(this.aiFlag) ||
          checkLength(this.ids.length) ||
          checkLength(this.cstList.length) ||
          checkLength(this.ctList.length)
        ) {
          let flag = check(this.teamTypeGroupsResult[1]);
          if (flag) {
            this.$message.error("请选择团队信息");
            this.courseST.editinformation = true;
            this.courseST.finishinformation = false;
            this.courseST.defaultinformation = false;
            this.dataListLoading = false;
            return;
          }
          this.$message.error("请完成基本信息");
          this.courseST.editinformation = true;
          this.courseST.finishinformation = false;
          this.courseST.defaultinformation = false;
          this.dataListLoading = false;
          return;
        }
      }
      // 课程介绍改变图标
      this.courseST.defaultlessonrefer = false;
      (this.courseST.editlesson = false), (this.courseST.finishlesson = true);
      // if(this.aiFlag==1){
      //   if(this.aiExamFlag==""){
      //     this.$message.warning('请完成基本信息')
      //     this.courseST.editinformation = true;
      //     this.courseST.finishinformation = false;
      //     this.courseST.defaultinformation = false;
      //     this.dataListLoading=false
      //     return
      //   }
      // }
      // 课程介绍判断
      if (check(this.moduleOne) || checkLength(this.moduleOneIntro)) {
        this.$message.error("请完成课程介绍，模块一内容");
        this.courseST.defaultlessonrefer = false;
        (this.courseST.editlesson = true), (this.courseST.finishlesson = false);
        this.dataListLoading = false;
        return;
      }
      if (!checkLength(this.moduleTwoIntro)) {
        if (check(this.moduleTwo)) {
          this.$message.error("请完成课程介绍，模块二内容");
          this.courseST.defaultlessonrefer = false;
          (this.courseST.editlesson = true),
            (this.courseST.finishlesson = false);
          this.dataListLoading = false;
          return;
        }
      }
      //课程介绍，模块一判断
      if (this.moduleOneIntro.length > 0) {
        for (let i = 0; i < this.moduleOneIntro.length; i++) {
          if (this.moduleOneIntro[i].type == 1) {
            //模块一文本
            if (
              this.moduleOneIntro[i].value == "" ||
              this.moduleOneIntro[i].value == null
            ) {
              this.$message.error("模块一的文字信息内容不能为空");
              this.courseST.defaultlessonrefer = false;
              (this.courseST.editlesson = true),
                (this.courseST.finishlesson = false);
              this.dataListLoading = false;
              return;
            }
          }
          // 模块一图片
          if (this.moduleOneIntro[i].type == 2) {
            if (
              this.moduleOneIntro[i].value == "" ||
              this.moduleOneIntro[i].value == null
            ) {
              this.$message.error("请上传课程介绍模块一的图片");
              (this.courseST.deafultuppic = false),
                (this.courseST.edituppic = true),
                (this.courseST.finishuppic = false),
                (this.dataListLoading = false);
              return;
            }
          }
          // 模块一视频
          if (this.moduleOneIntro[i].type == 3) {
            if (
              this.moduleOneIntro[i].value == "" &&
              this.moduleOneIntro[i].videoUrl == ""
            ) {
              this.$message.error("请上传课程介绍模块一视频");
              (this.courseST.deafultuppic = false),
                (this.courseST.edituppic = true),
                (this.courseST.finishuppic = false),
                (this.dataListLoading = false);
              return;
            }
          }
        }
      }
      if (this.moduleTwoIntro.length > 0) {
        for (let i = 0; i < this.moduleTwoIntro.length; i++) {
          if (this.moduleTwoIntro[i].type == 1) {
            //模块一文本
            if (
              this.moduleTwoIntro[i].value == "" ||
              this.moduleTwoIntro[i].value == null
            ) {
              this.$message.error("模块二的文字信息内容不能为空");
              this.courseST.defaultlessonrefer = false;
              (this.courseST.editlesson = true),
                (this.courseST.finishlesson = false);
              this.dataListLoading = false;
              return;
            }
          }
          // 模块一图片
          if (this.moduleTwoIntro[i].type == 2) {
            if (
              this.moduleTwoIntro[i].value == "" ||
              this.moduleTwoIntro[i].value == null
            ) {
              this.$message.error("请上传课程介绍模块二的图片");
              (this.courseST.deafultuppic = false),
                (this.courseST.edituppic = true),
                (this.courseST.finishuppic = false),
                (this.dataListLoading = false);
              return;
            }
          }
          // 模块一视频
          if (this.moduleTwoIntro[i].type == 3) {
            if (
              this.moduleTwoIntro[i].value == "" &&
              this.moduleTwoIntro[i].videoUrl == ""
            ) {
              this.$message.error("请上传课程介绍模块二视频");
              (this.courseST.deafultuppic = false),
                (this.courseST.edituppic = true),
                (this.courseST.finishuppic = false),
                (this.dataListLoading = false);
              return;
            }
          }
        }
      }

      //上传图片
      (this.courseST.deafultuppic = false),
        (this.courseST.edituppic = false),
        (this.courseST.finishuppic = true);

      // 上传图片判断
      if (check(this.imageUrlThired)) {
        this.$message.error("请上传列表图片");
        (this.courseST.deafultuppic = false),
          (this.courseST.edituppic = true),
          (this.courseST.finishuppic = false);
        this.dataListLoading = false;
        return;
      }
      // 章节设置
      (this.courseST.defaultchapter = false),
        (this.courseST.editchapter = false),
        (this.courseST.finishchapter = true);

      // 章判断
      if (this.chapters.length == 0) {
        this.$message.warning("请添加章节内容");
        (this.courseST.defaultchapter = false),
          (this.courseST.editchapter = true),
          (this.courseST.finishchapter = false);
        this.dataListLoading = false;
        return;
      }
      // 节为空判断

      if (this.chapters.length > 0) {
        for (let i = 0; i < this.chapters.length; i++) {
          if (this.chapters[i].name == "" || this.chapters[i].name == null) {
            this.$message.error("请添加" + `${i + 1}` + "章下的章名称");
            (this.courseST.defaultchapter = false),
              (this.courseST.editchapter = true),
              (this.courseST.finishchapter = false);
            this.dataListLoading = false;
            return;
          }
          if (checkLength(this.chapters[i].sections)) {
            this.$message.error("请添加" + `${i + 1}` + "章下的节信息");
            (this.courseST.defaultchapter = false),
              (this.courseST.editchapter = true),
              (this.courseST.finishchapter = false);
            this.dataListLoading = false;
            return;
          } else {
            console.log(this.chapters, "================ssssss");
            for (let len = 0; len < this.chapters[i].sections.length; len++) {
              if (
                this.chapters[i].sections[len].chapterType == "" ||
                this.chapters[i].sections[len].chapterType == null
              ) {
                this.$message.error("请填写" + `${i + 1}` + "章下的节信息");
                (this.courseST.defaultchapter = false),
                  (this.courseST.editchapter = true),
                  (this.courseST.finishchapter = false);
                this.dataListLoading = false;
                return;
              }
            }
          }
        }
      }
      //  选修判断

      for (let i = 0; i < this.chapters.length; i++) {
        let hasNotTag = "";
        for (let len = 0; len < this.chapters[i].sections.length; len++) {
          if (this.chapters[i].sections[len].tag.length == 0) {
            hasNotTag = true;
          }
          if (this.chapters[i].sections[len].tag.length == 1) {
            if (this.chapters[i].sections[len].tag[0] == "更新")
              hasNotTag = true;
          }
        }
        if (!hasNotTag) {
          this.$message.error(`${i + 1}章下的节不能都为选修`);
          (this.courseST.defaultchapter = false),
            (this.courseST.editchapter = true),
            (this.courseST.finishchapter = false);
          this.dataListLoading = false;
          return;
        }
      }

      this.contents = JSON.stringify(this.contents);
      this.contents = JSON.stringify(this.contents);
      this.contentsJs = this.contents;
      // this.moduleOneIntro = []
      // this.moduleTwoIntro = []
      // // 模块一输入内容
      console.log(this.moduleOneIntro, "moduleTwoIntro==============");
      this.jsonlist = JSON.stringify(this.moduleOneIntro);
      console.log(this.jsonlist, "转换后数据");

      this.jsonlistT = JSON.stringify(this.moduleTwoIntro);
      // this.jsonlistT = JSON.stringify(this.jsonlistT);
      this.jsonlistT = this.jsonlistT.replace(/\\n/g, "\n");
      console.log(this.jsonlistT, "转换后数据");
      // 列表图片
      if (this.imageUrlThired) {
        this.listPic = this.imageUrlThired;
      }
      // 标签选修
      let classssid = this.classifyId;
      console.log(classssid);
      console.log(classssid[classssid.length - 1]);
      classssid = classssid[classssid.length - 1];
      classssid = classssid + "";
      console.log(classssid);

      const ccList = [];
      const examList = [];
      const courseDuration = [];
      let option = "";
      let options = "";
      this.chapters.map((item, index) => {
        const obj = {
          chapterName: item.name,
          sequence: index + 1,
          subList: [],
        };
        ccList.push(obj);
        item.sections.map((_item, _index) => {
          console.log(_item.tag, "item");
          if (_item.tag.length === 1) {
            if (_item.tag[0] == "选修") {
              (option = 1), (options = 0);
            } else if (_item.tag[0] == "更新") {
              (option = 0), (options = 1);
            }
          } else if (_item.tag.length === 2) {
            (option = 0), (options = 0);
          } else {
            (option = 1), (options = 1);
          }

          const _obj = {
            sequence: _index + 1,
            subChapterName: _item.name,
            subChapterPath: _item.location,
            optionalStudyType: options,
            optional: option,
            chapterType: _item.chapterType,
            content: _item.content,
            resourceId: _item.resourceId,
            duration: _item.duration,
            homeworkName: _item.homeworkName,
            approvalMode: _item.approvalMode,
            approvalStation: _item.approvalStation,
          };
          ccList[index]["subList"].push(_obj);
          examList.push(_item.chapterType);
          // 计算时长
          if (_item.duration != null) {
            if (typeof _item.duration === "string") {
              courseDuration.push(_item.duration - 0);
            } else {
              courseDuration.push(_item.duration);
            }
          }
        });
      });

      console.log(checkSum(courseDuration), "学习时长");
      this.durationResult = checkSum(courseDuration);
      if (
        this.durationResult == "" ||
        this.durationResult == null ||
        this.durationResult.length < 0
      ) {
        this.$message.warning("课程时长不能为空");
        this.courseST.editinformation = true;
        this.courseST.finishinformation = false;
        this.courseST.defaultinformation = false;
        this.dataListLoading = false;
        return;
      }

      const courseRecommendList = [];
      if (this.referList) {
        this.referList.map((item, index) => {
          const obj = {
            bizType: 1,
            bizId: item.courseId,
            sequence: index + 1,
          };
          courseRecommendList.push(obj);
        });
      }

      const faqList = [];
      this.inputList.map((item, index) => {
        const obj = {
          questionDesc: item.question,
          answerDesc: item.answer,
        };
        faqList.push(obj);
      });

      if (faqList) {
        for (let faqindex = 0; faqindex < faqList.length; faqindex++) {
          if (
            faqList[faqindex].questionDesc == "" ||
            faqList[faqindex].questionDesc == null ||
            faqList[faqindex].questionDesc.length < 0 ||
            faqList[faqindex].questionDesc.trim().length == 0
          ) {
            this.$message.warning(`第${faqindex + 1}问题的问题不能为空`);
            this.dataListLoading = false;
            (this.courseST.defaultquestion = false),
              (this.courseST.editquestion = true),
              (this.courseST.finishquestion = false);
            return;
          }
          if (
            faqList[faqindex].answerDesc == "" ||
            faqList[faqindex].answerDesc == null ||
            faqList[faqindex].answerDesc.length < 0 ||
            faqList[faqindex].answerDesc.trim().length == 0
          ) {
            this.$message.warning(`第${faqindex + 1}问题的答案不能为空`);
            this.dataListLoading = false;
            (this.courseST.defaultquestion = false),
              (this.courseST.editquestion = true),
              (this.courseST.finishquestion = false);
            return;
          }
        }
      }

      // 保存条件
      console.log(ccList, "ccList");
      console.log(examList, "examList");
      let newExamList = examList.filter((item) => item == 80);
      console.log(newExamList.length, "newnewnew");
      // listExam = ccList.filter((item) =>
      //   item.has(item.subList.chapterType === 70)
      // );
      //至少选择一个AI资源
      if (this.aiFlag == 1) {
        if (newExamList.length < 1) {
          this.$message.warning("AI资源至少选一门AI课程");
          this.courseST.defaultchapter = false;
          this.courseST.editchapter = true;
          this.courseST.finishchapter = false;
          this.dataListLoading = false;
          return;
        }
      }
      // 必须只能选择一个AI资源
      if (this.aiExamFlag == 1) {
        if (examList.length != 1) {
          this.$message.warning("AI考试只能选择一门AI课程");
          this.courseST.defaultchapter = false;
          this.courseST.editchapter = true;
          this.courseST.finishchapter = false;
          this.dataListLoading = false;
          return;
        }
      }
      const data = {
        courseVO: {
          courseName: this.courseName,
          courseNameEn: this.courseNameEn,
          abbrEn: "",
          brandId: this.brandId,
          teamType: this.teamTypeGroupsResult[0],
          teamTypeChild: this.teamTypeGroupsResult[1],
          startDate: "",
          keyword: this.keyword,
          isLimit: this.isLimit,
          isPush: 1,
          isFree: this.isFree,
          consumeScore: "",
          hasCertificateFlag: this.hasCertificateFlag,
          isReward: "",
          rewardScore: 6,
          startDateStr: "1979-1-1",
          target: "",
          duration: this.durationResult,
          courseIntro: "",
          courseType: 1,
          classifyId: classssid,
          ktcCode: this.ktcCode,
          moduleOne: this.moduleOne,
          moduleOneIntro: this.jsonlist,
          moduleTwo: this.moduleTwo,
          moduleTwoIntro: this.jsonlistT,
          aiFlag: this.aiFlag,
          aiExamFlag: this.aiExamFlag,
          isExerciseRep: this.isExerciseRep,
          isExamRep: this.isExamRep,
          showExerciseInfo: this.showExerciseInfo,
          showExamInfo: this.showExamInfo,
          aiTag: this.aiTag,
          isOrderStudy: this.isOrderStudy,
        },
        coursePicVO: {
          bannerPic: "",
          listPic: this.listPic,
        },
        csList: this.ids,
        cstList: this.cstList,
        ctList: this.ctList,

        faqList: [
          {
            questionDesc: "测试问题1",
            answerDesc: "回答问题1",
          },
        ],
      };
      this.$request
        .post("/course/saveCourse", {
          ...data,
          ccList,
          courseRecommendList,
          faqList,
        })
        .then((res) => {
          this.dataListLoading = false;
          this.saveCourseId = res;
          console.log(res, "保存返回数据");
          const saveId = this.saveCourseId;
          console.log(saveId, "传送的数据");
          let tabName = this.$store.state.contentTabsActiveName;
          this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
            (item) => item.name !== tabName
          );
          if (tabName === this.$store.state.contentTabsActiveName) {
            this.$router.push({
              name: this.$store.state.contentTabs[
                this.$store.state.contentTabs.length - 1
              ].name,
            });
          }
          this.$router.push({
            path: "/ifo",
            query: { saveId: saveId },
          });
          setTimeout(function () {}, 100);
          this.$eventHub.$emit("saveId", saveId);
        });
    },

    // 搜索资源
    onBtnSelectResource() {
      this.pageResource = 1;
      this.onBtn();
    },
    onBtnSeach() {
      this.pageResource = 1;
      this.onBtn();
    },
    onBtn() {
      this.limit = 10;
      console.log(this.TypeDescId, "====================TypeDescId");
      if (this.TypeDescId == null) {
        this.TypeDescId = "";
      }
      this.isresourceShow = true;
      let url = `/course/listResourceByPageNew?keyword=${
        this.formInline.name
      }&createName=${this.CreateName}&updateName=${
        this.UpdateName
      }&typeDescId=${
        this.TypeDescId
      }&notIncludedAudio=${9}&status=${1}&notIncluded=${50}`;
      if (this.groupId) {
        url += `&groupId=${this.groupId}`;
      }
      this.$request
        .post(url, {
          pageNo: this.pageResource,
          groupId: this.groupId,
          pageSize: this.limit,
        })
        .then((res) => {
          this.isresourceShow = false;
          this.totalCountResource = res.totalCount;
          this.totalCount = res.totalCount;
          this.tableData = res.data;
          console.log("刷新后数据", this.tableData);
        });
    },
    // 随机数
    getRandomArrayElements(arr, count) {
      var shuffled = arr.slice(0),
        i = arr.length,
        min = i - count,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },
    team57() {
      this.$request
        .post(`/course/getTeamTypeChild?teamTypeId=${57}`, {})
        .then((res) => {
          res.map((item) => {
            this.teamTypeGroups[6].children.push({
              label: item.label,
              value: item.value,
            });
          });
          if (this.teamTypeGroups[6].children.length == 0) {
            this.team57();
          }
          console.log(this.teamTypeGroups, "this.teamTypeGroups");
        });
    },
  },
  watch: {
    tagsImportant: {
      handler(newName, oldName) {
        if (newName) {
          this.keyword = "";
          this.tagsImportant.map((item) => {
            if (this.keyword != "") {
              this.keyword = this.keyword + "," + item.text;
            } else {
              if (item.text) {
                this.keyword = item.text;
              } else {
                this.keyword = item;
              }
            }
          });

          if (this.keyword == "") {
            this.referList = [];
          } else {
            this.$request
              .post(`/course/getRecommendCourse?keywords=${this.keyword}`, {
                ps: { pageNo: 1, pageSize: 4 },
              })
              .then((res) => {
                // console.log(,"关联课程初始数据")
                this.referList = res.data.splice(0, 4);
                // this.referList =res
                console.log(this.referList, "关联课程数据");
              });
          }

          console.log(this.keyword, "this.keyword");
        }
      },
      immediate: true,
      deep: true,
    },

    isDragging(newValue) {
      console.log("监听事件进来了");
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
    },
  },
  created() {
    this.getListBrand();
    this.getListTeamParentType();
    this.onAddChapter();
    this.getTeamTypeClassify();
    this.isresourceShow = true;
    // this.$request
    //   .post("/course/listResourceByPageNew", {
    //     pageNo: this.page,
    //     pageSize: this.limit,
    //   })
    //   .then((res) => {
    //     this.isresourceShow = false;
    //     this.totalCountResource = res.totalCount;
    //     this.tableData = res.data;
    //   });
    // 关联课程数据
    this.isShowRefer = true;
    this.$request
      .post("/course/searchCourseByPage", {
        ps: { pageNo: this.pageRefer, pageSize: this.limitRefer },
        courseSearchVO: {
          courseStatus: 2,
        },
      })
      .then((res) => {
        this.isShowRefer = false;
        this.referData = res.data;
        this.totalRefer = res.totalCount;
        console.log(this.referList, "关联课程数据");
      });

    // 业务团队数据
    // this.selectGroup()
    this.$request.post("/course/listResourceGroup", {}).then((res) => {
      this.data = res;
      console.log(this.data, "左侧列表数据");
    });
    this.$request.post("/course/searchClassify", {}).then((res) => {
      var jsonObject = JSON.parse(res);
      this.options = this.getTreeData(jsonObject);
      console.log(this.options, "this.options");
    });
  },

  // activated(){
  //   console.log(111111111111111)
  //   Object.assign(this.$data, this.$options.data.call(this))
  //   console.log(11,this.$data)
  //   console.log(22,this.$options.data.call(this))
  // }
};
